// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"708":"222aa3cc","921":"23947f21"}[chunkId] + ".chunk.js";
};